import { NiraBusId, ScopedBus } from "types/busType";

// Apollo's previousData outlives the saved list: unstar a bus and it stays in
// the previous result until the refetch lands, and when the last favorite goes
// the query is skipped, so no refetch ever lands and the bus would stay forever.
//
// Returned in the saved list's order. The fetch has no order_by, so Postgres
// picks the row order, and the saved list is newest first.
export const keepSavedFavorites = (
    scopedBuses: ReadonlyArray<ScopedBus>,
    niraBusIds: ReadonlyArray<NiraBusId>
): ReadonlyArray<ScopedBus> => {
    const byNiraBusId = new Map(
        scopedBuses.map((scopedBus) => [scopedBus.bus.niraBusId, scopedBus])
    );
    return niraBusIds
        .map((niraBusId) => byNiraBusId.get(niraBusId))
        .filter((scopedBus): scopedBus is ScopedBus => scopedBus !== undefined);
};
